import BasicLayout from "@/layouts/basic-layout";

const meta = {
    auth: false,
    cache: false,
};
export default {
    path: "/knowledgeBase",
    name: "knowledgeBase",
    redirect: {
        name: "knowledgeBase",
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: "/knowledgeBase/government",
            name: "government",
            meta: {
                ...meta,
                title: "政务信息库",
            },
            component: () => import("@/pages/knowledgeBase/government/index.vue"),
        },
        {
            path: "/knowledgeBase/informationCollection1/:queryType",
            name: "informationCollection1",
            meta: {
                ...meta,
                title: "待办信息",
            },
            component: () => import("@/pages/knowledgeBase/informationCollection/index.vue"),
        },
        {
            path: "/knowledgeBase/informationCollection2/:queryType",
            name: "informationCollection2",
            meta: {
                ...meta,
                title: "已办信息",
            },
            component: () => import("@/pages/knowledgeBase/informationCollection/index.vue"),
        },
        {
            path: "/knowledgeBase/informationCollection3/:queryType",
            name: "informationCollection3",
            meta: {
                ...meta,
                title: "暂存信息",
            },
            component: () => import("@/pages/knowledgeBase/informationCollection/index.vue"),
        },
        {
            path: "/knowledgeBase/correctionInfo/:queryType",
            name: "amendList",
            meta: {
                ...meta,
                title: "纠错信息",
            },
            component: () => import("@/pages/knowledgeBase/amend/AmendList.vue"),
        },
        {
            path: "/knowledgeBase/correctionAudit/:queryType",
            name: "amendAuditList",
            meta: {
                ...meta,
                title: "纠错审核",
            },
            component: () => import("@/pages/knowledgeBase/amend/AmendList.vue"),
        },
        {
            path: '/knowledgeBase/collected',
            name: 'collected',
            meta: {
              title: '收藏知识'
            },
            component: () => import('@/pages/knowledgeBase/informationCollection/collected.vue')
        },
    ],
};
